module.exports = __webpack_public_path__ + "static/img/144_TO8_1849_og.09d9cc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/144_TO8_1849_og.jpg
// module id = OhuC
// module chunks = 0